/* eslint-disable max-len */
/* eslint-disable import-helpers/order-imports */
import React, {
  useState, useCallback, forwardRef, useImperativeHandle, useRef,
} from 'react';

import {
  Badge,
  Button,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
} from 'reactstrap';
import { format, parseISO } from 'date-fns';

import { numberToCurrency } from '../../utils/functions';
import FinanceiroEdit from '../Financeiro/Edit';

function ModalFinanceiroEspecialidadeUso(_props, ref) {
  const [show, setShow] = useState(false);
  const [modalTitle, setModalTitle] = useState('Contas vinculadas');
  const [accounts, setAccounts] = useState([]);
  const modalFinanceiroEdit = useRef();

  useImperativeHandle(ref, () => ({
    show: ({ title, accounts: accountsParam }) => {
      setModalTitle(title || 'Contas vinculadas');
      setAccounts(Array.isArray(accountsParam) ? accountsParam : []);
      setShow(true);
    },
    close: () => {
      setShow(false);
      setAccounts([]);
    },
  }));

  const toggle = useCallback(() => {
    setShow((prev) => !prev);
  }, []);

  const formatDate = useCallback((value, fallback = '-') => {
    if (!value) return fallback;
    try {
      return format(parseISO(value), 'dd/MM/yyyy');
    } catch (error) {
      return fallback;
    }
  }, []);

  return (
    <Modal isOpen={show} toggle={toggle} fullscreen>
      <ModalHeader>
        <strong>{modalTitle}</strong>
        <Button
          className="close position-absolute top-4 right-4 py-1 px-2"
          onClick={toggle}
        >
          <i className="fas fa-times" />
        </Button>
      </ModalHeader>
      <ModalBody>
        <Container fluid>
          <FinanceiroEdit ref={modalFinanceiroEdit} />
          <Row>
            <Col>
              <div className="table-responsive">
                <Table striped hover>
                  <thead>
                    <tr>
                      <th className="text-center text-nowrap">Módulo</th>
                      <th className="text-nowrap">Profissional</th>
                      <th className="text-nowrap">Paciente</th>
                      <th className="text-nowrap">Grupo</th>
                      <th className="text-nowrap">Mês/Ano</th>
                      <th className="text-nowrap">Data Atendimento</th>
                      <th className="text-nowrap">Tipo Lançamento</th>
                      <th className="text-nowrap">Empresa</th>
                      <th className="text-nowrap">Valor</th>
                      <th className="text-nowrap">Fatura</th>
                      <th className="text-nowrap">Situação</th>
                      <th className="text-nowrap">Vencimento</th>
                      <th className="text-nowrap">Fechamento</th>
                      <th className="text-center text-nowrap" style={{ width: '80px' }}>
                        Ações
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {accounts.map((row) => {
                      const dataFechamento = row.dataFechamento || row.datafechamento;

                      return (
                        <tr key={row._id}>
                          <td className="text-center text-nowrap">
                            {row.tipo === 'conta-pagar' ? (
                              <Badge color="danger" tag="div">
                                <i className="fa-solid fa-money-bill-transfer mr-2" />
                                a Pagar
                              </Badge>
                            ) : (
                              <Badge color="success" tag="div">
                                <i className="fa-solid fa-hand-holding-dollar mr-2" />
                                a Receber
                              </Badge>
                            )}
                          </td>
                          <td className="text-nowrap">{row.profissionalNome || '-'}</td>
                          <td className="text-nowrap">{row.clienteNome || '-'}</td>
                          <td className="text-nowrap">{row.grupoNome || '-'}</td>
                          <td className="text-nowrap">{row.mes && row.ano ? `${row.mes}/${row.ano}` : '-'}</td>
                          <td className="text-nowrap">{formatDate(row.startAtendimentoDate)}</td>
                          <td className="text-nowrap">{row.tipoLancamento || '-'}</td>
                          <td className="text-nowrap">{row.razaoSocial || '-'}</td>
                          <td className="text-nowrap">{numberToCurrency(row?.tipoLancamento === 'REEMBOLSO' ? row?.valorReembolso || 0 : row?.valor || 0)}</td>
                          <td className="text-nowrap">{row.fatura || '-'}</td>
                          <td className="text-nowrap">{row.situacao || '-'}</td>
                          <td className="text-nowrap">{formatDate(row.dataVencimento)}</td>
                          <td className="text-nowrap">{formatDate(dataFechamento)}</td>
                          <td className="text-center">
                            <Button color="primary" onClick={() => modalFinanceiroEdit.current.show(row)}>
                              <i className="fa-solid fa-pen" />
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
                {accounts.length === 0 && (
                  <div className="text-center p-4">
                    <i className="fa-solid fa-inbox fa-2x text-muted" />
                    <p className="mt-2 text-muted">Nenhuma conta vinculada encontrada</p>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Fechar
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default forwardRef(ModalFinanceiroEspecialidadeUso);
